






























































import { bookModelProvider } from '../model'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { ref } from '@vue/composition-api'

export default defineClassComponent(
  () =>
    class {
      bookModel = bookModelProvider.inject()

      isFold = ref(true)

      handleFoldClick = () => {
        this.isFold.value = !this.isFold.value
      }

      handleBuyClick = (url: string) => {
        dcb.navigateTo({ url })
      }
    },
)
